import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import type { ButtonProps } from '../../components/button/types';
import { GLOBAL_ICONS } from '../../util/vars';
import { Button } from '../../components';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends ButtonProps, HTMLProps {
  children?: string | null,
}

const EditButton = ({
  children,
  ...other
}: Props): JSX.Element => {

  const { translate } = useI18n();

  return (
    <Button icon={GLOBAL_ICONS.edit} size={'sm'} align={'start'} asLink {...other}>
      {children ?? translate('components.BUTTONS.EDIT')}
    </Button>
  );
};

EditButton.displayName = 'EditButton';

export default EditButton;
